import React from 'react';
import { resolveImagePath } from '@/utils/imageMap';

interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className = '' }) => {
  return (
    <header className={`bg-gray-200 ${className}`}>
      {/* Top header bar with logo, phone, and social */}
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo and tagline */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img
                src={resolveImagePath('/wp-content/uploads/2019/04/Good-News-Garage-logo_237.png')}
                alt="Good News Garage"
                className="h-16 w-auto"
              />
            </a>
            <div className="ml-3 text-sm text-gray-700 hidden md:block">
              Doing it all for over 30 years
            </div>
          </div>

          {/* Contact info and social media */}
          <div className="flex items-center space-x-4">
            <div className="text-gray-700 font-medium">
              Call Us! 617-354-5383
            </div>
            <div className="flex space-x-2">
              {/* Facebook icon */}
              <a
                href="https://www.facebook.com/GNGCambridge/"
                className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white hover:bg-blue-700 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              {/* Email icon */}
              <a
                href="mailto:goodnews@gngcambridge.com"
                className="w-8 h-8 bg-gray-600 rounded-full flex items-center justify-center text-white hover:bg-gray-700 transition-colors"
                aria-label="Email"
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation menu */}
      <nav className="bg-white border-t border-gray-300">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center">
            <ul className="flex space-x-8 py-4">
              <li>
                <a
                  href="/"
                  className="text-gray-700 hover:text-red-600 transition-colors font-medium"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about-us"
                  className="text-gray-700 hover:text-red-600 transition-colors font-medium"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-gray-700 hover:text-red-600 transition-colors font-medium"
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/make-appointment"
                  className="text-gray-700 hover:text-red-600 transition-colors font-medium"
                >
                  Make an Appointment
                </a>
              </li>
              <li>
                <a
                  href="/contact-us"
                  className="text-gray-700 hover:text-red-600 transition-colors font-medium"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;